<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #F5F7FA;
  font-size: 16px;
}
/*重置CSS*/
html, body, ul, li, ol, dl, dd, dt, p, h1, h2, h3, h4, h5, h6, form, fieldset, legend, img { margin:0; padding:0; font-size: 16px;}
fieldset, img { border:none; }
img{display: block;}
address, caption, cite, code, dfn, th, var { font-style:normal; font-weight:normal; }
ul, ol { list-style:none; }
input::-moz-focus-inner { border:none; padding:0; }
select, input { vertical-align:middle; }
select, input, textarea { margin:0; }
input[type="submit"], input[type="button"], input[type="text"], input[type="password"], input[type="tel"], textarea { outline-style:none; -webkit-appearance:none; }
textarea { resize:none; }
table { border-collapse:collapse; }
a { text-decoration: none;}

.container {
  margin: 0 auto;
}

@media (min-width: 376px){

}
@media (min-width: 415px){

}
@media (min-width: 640px){

}
@media (min-width: 720px){

}
@media (min-width: 750px){

}
@media (min-width: 800px){

}
@media (min-width: 1024px){
  .container {
    width: 100%;
  }
}
@media (min-width: 1100px){

}
@media (min-width: 1280px){

}
@media (min-width: 1366px){
  .container {
    width: 100%;
  }
}
@media (min-width: 1440px){
  .container {
    width: 100%;
  }
}

@media (min-width: 1680px){
  .container {
    width: 100%;
  }
}
@media (min-width: 1920px){
  .container {
    width: 100%;
  }
}
html,body,#app{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue